import { render, staticRenderFns } from "./JournalismInfo.vue?vue&type=template&id=679b83fa&scoped=true&"
import script from "./JournalismInfo.vue?vue&type=script&lang=js&"
export * from "./JournalismInfo.vue?vue&type=script&lang=js&"
import style0 from "./JournalismInfo.vue?vue&type=style&index=0&id=679b83fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b83fa",
  null
  
)

export default component.exports